import { InfoOutline } from '@app/components/various/Icons';
import { Tooltip } from '@app/components/various/Tooltip';
import { cn } from '@app/utils/cn';
import { isDefined } from '@app/utils/is';
import { renderValue } from '@app/utils/renderValue';
import { Cms } from '@typings';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props<T extends keyof Cms.Page> {
  page: Cms.Page;
  property: T;
  render?: (value: Cms.Page[T]) => React.ReactNode;
  children: React.ReactNode;
  previousClassName?: string;
}

export const PreviouslyTableCell = ({ page, property, render = renderValue, children, previousClassName }: Props<keyof Cms.Page>) => {
  const { t } = useTranslation(['cms']);

  const { snapshot } = page;
  const currentValue = page[property];
  const previousValue = isDefined(snapshot) ? snapshot[property] : undefined;
  const valueChanged = JSON.stringify(previousValue) !== JSON.stringify(currentValue);
  const showPreviousValue = isDefined(previousValue) && valueChanged && page.status === 'published_with_changes';

  return (
    <div className={cn('flex h-5 flex-nowrap items-center overflow-hidden', { [previousClassName ?? '']: showPreviousValue })}>
      {children}
      {showPreviousValue && (
        <Tooltip
          content={
            <div className="body-5">
              <span className="body-4">{t('cms:published')}:&nbsp;</span>
              {render(previousValue)}
            </div>
          }
        >
          <span aria-hidden="true" className="z-interactiveTableItem size-4 cursor-pointer">
            <InfoOutline className="size-4" />
          </span>
        </Tooltip>
      )}
    </div>
  );
};
